"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeShippingOfferItemHandler = removeShippingOfferItemHandler;
var _removeShippingOfferItemFailed = require("@ori-events/remove-shipping-offer-item-failed");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _api = require("../api");
var _logger = require("../logger");
const dispatchErrorEvent = detail => {
  const errorEvent = new CustomEvent(_removeShippingOfferItemFailed.Name, {
    detail
  });
  window.dispatchEvent(errorEvent);
};
async function removeShippingOfferItemHandler(event, {
  client,
  sessionId,
  tenant
}) {
  const headers = {
    [_fetching.TENANT_CONTEXT]: tenant
  };
  try {
    await (0, _globalApiClientReact.deleteShoppingSessionShippingJokerChoice)(client, sessionId, headers);
  } catch (error) {
    _logger.mainLogger.error(error, {
      message: 'Error while removing shipping offer choice in remove-shipping-offer-item event.'
    });
    dispatchErrorEvent({
      isSuccess: false,
      localizedMessage: '',
      message: 'Removal of shipping offer choice via API call failed.'
    });
    return false;
  }
  const data = await (0, _api.fetchShoppingContextData)();
  if ((0, _removeShippingOfferItemFailed.isRemoveShippingOfferItemErrorResponse)(data)) {
    dispatchErrorEvent(data);
    return false;
  }
  return data;
}